// Re-export trade eligibility types from shared (moved to avoid circular dependency)
export {
  WarnedTradeReason,
  BlockedTradeReason,
  UneligibleTradeReason,
  blockedTradeReasons,
} from "../shared/campaign-types";
